import { LuSearch,LuSearchCheck } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      rows: {

        row1: [
          {
            name: "importProductMainDescription",
            actionText: "Description",
            label: "Init",
            outerIconName: LuSearch,
            component: "textarea",
            placeholder:
              "MACHINED PARTS & SPARES - BEARING BCK*RAW*Z1*Z3 DW.NO.262--07-0100/000",
            width: "100%",
            height: 95,
            sx: {
              borderRadius: 10,
            },
            required: true, 
          },
          {
            name: "importProductMainDescriptionId",
            actionText: "Description",
            label: "Init",
            outerIconName: LuSearch,
            component: "textarea",
            width: "100%",
            height: 110,
            sx: {
              borderRadius: 10,
            },
            type: "autocomplete",
            endpoint: "getDescription",
            required: true, 
          },
          {
            component: "icon-toggle",
            name: "isDescription",
            checkedIcon: LuSearchCheck,
            uncheckedIcon: LuSearch,
            color: "primary",
            defaultValue: false,
            visibleOn : true
            // size : "medium",
          },
          {
            component: "icon-toggle",
            name: "isInvoiceDescription",
            checkedIcon: LuSearchCheck,
            uncheckedIcon: LuSearch,
            color: "primary",
            defaultValue: false,
            visibleOn: true,
            // size : "medium",
          },
        ],
        row2: [
          {
            name: "importProductMainUnitPrice",
            label: "Unit",
            component: "text-field",
            width: "30%",
            placeholder: "0.0000",
            dataType: "float",
          },
          {
            name: "importInvoiceCurrency",
            component: "text-field",
            width: "15%",
            placeholder: "00",
            disabled: true,
          },
          {
            name: "importProductMainCTHorHSNCode",
            label: "CTH/HSN No.",
            icon: LuSearch,
            component: "text-field",
            width: "30%",
            type: "autocomplete",
            required: true,
            endpoint: "getHsnCodeMaster",
            filterEndPoint: "getFilterHsnCode",
          },
          {
            name: "HSNCode",
            label: "HSCode",
            component: "outlinebutton",
            // action: "navigate",
            // navigateTo: "/export/create-customer",
            variant: "bodySmallMedium",
            width: "20%",
            sx: {
              mt: "32px",
            },
            disabled: true,
          },
        ],

        row3: [
          {
            name: "importProductMainIsFOCItem",
            label: "FOC Item",
            component: "dropdown",
            width: "20%",
            options: [
              {
                label: "Yes",
                value: true,
              },
              {
                label: "No",
                value: false,
              },
            ],
          },
          {
            name: "importProductMainQuantity",
            label: "Quantity",
            component: "text-field",
            width: "20%",
            placeholder: "00",
            dataType: "int",
            required: true,
          },
          {
            name: "importProductMainQuantityUnitId",
            component: "text-field",
            width: "20%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "importProductMainAmount",
            label: "Amount",
            component: "text-field",
            width: "25%",
            placeholder: "00",
            dataType: "int",
          },
          {
            name: "importInvoiceCurrency",
            // label: "",
            component: "text-field",
            width: "15%",
            placeholder: "USD",
            disabled: true,
          },
        ],
      },
    },
  ],
};
